import { connect } from 'react-redux';
import { addLineItemsBegin, getFeeTypesBegin } from '../../../store/actions/accounting.actions';
import { getFeeTypes } from '../../../store/selectors/accounting.selectors';
import Invoice from './Invoice';

const mapStateToProps = (state: any) => ({
    feeTypes: getFeeTypes(state),
});

const mapDispatchToProps = {
    getFeeTypes: getFeeTypesBegin,
    addLineItems: addLineItemsBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(Invoice);
